<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <!-- <CCardHeader>
	<CButton color="primary" class="px-4" @click="add()">Add waste</CButton>
	</CCardHeader> -->
    <CCardHeader class="waste-header">
      <slot name="header">
        <span><CIcon name="cil-grid" class="mr-2" /> {{ caption }}</span>
        <CRow>
          <CCol sm="4">
            <CInput
              label="From Date"
              type="date"
              :value="clientvise_fromdate_value"
              id="clientvise_fromdate"
              @input="dateFilter_client"
            />
          </CCol>
          <CCol sm="4">
            <CInput
              label="To Date"
              type="date"
              :value="sitevise_todate_value"
              id="clientvise_todate"
              @input="dateFilter_client"
            />
          </CCol>
          <CCol sm="4">
            <CSelect
              label="Site"
              :options="plantcodeOptions"
              id="plantcodeOptions"
              placeholder="Select Site"
              v-on:change="getShuffledWasteDataFilter()"
            />
          </CCol>
        </CRow>
        <CButton
          color="primary"
          class="px-4"
          @click="add()"
          :class="addcondition ? '' : 'hidden'"
          >Add Waste</CButton
        >
      </slot>
    </CCardHeader>
    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="items"
          hover
          striped
          bordered
          small
          fixed
          caption="Waste list"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "./Waste_lifting_list.vue";
//import usersData from '../manage_waste_lifting/UsersData'
import axios from "axios";
export default {
  name: "Waste_lifting_list",
  data() {
    return {
      plantcodeOptions: [],
      siteArr: [],
      Plant_Code: 0,
      items: [],
      addcondition: "",
      editcondition: "",
      clientvise_fromdate_value: "",
      sitevise_todate_value: "",
	  isLoading: false
    };
  },
  props: {
    caption: {
      type: String,
      default: "Waste Request List",
    },
  },
  components: { CTableWrapper },
  mounted() {
    var self = this;

    var d = new Date();
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var today =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    self.sitevise_todate_value = today;

    d.setDate(d.getDate() - 7);
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var firstdate =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    self.clientvise_fromdate_value = firstdate;

    var app_roleId = JSON.parse(localStorage.getItem("app_roleId"));
    if (app_roleId == "1") {
      self.addcondition = "1";
    } else {
      var userRules = JSON.parse(localStorage.getItem("RoleWiseModules"));
      var modulefind = userRules.find(function (jsonitem, f) {
        if (jsonitem.Slug == "add_waste_lifting") {
          self.addcondition = "1";
        }
      });
    }
    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
    var requestInfo = {
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/GetSapSites",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
	this.isLoading = true;
    axios(config)
      .then((result) => {
		this.isLoading = false;
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          var siteOptionsArr = obj;

          this.siteArr = obj;
          var siteSingleArr = [];
          var selArr = siteOptionsArr.find(function (jsonitem, i) {
            siteSingleArr.push(jsonitem.Plant_Name);
          });
          this.plantcodeOptions = siteSingleArr;

          var self1 = self;
          var token = localStorage.getItem("auth");
          var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
          var requestInfo = {
            Token: token,
            RequestFromDate: self1.clientvise_fromdate_value,
            RequestToDate: self1.sitevise_todate_value,
            Session_User_Id: Session_User_Id,
            Plant_Code: "",
          };
          var data = JSON.stringify(requestInfo);
          //console.log(data);
          var config = {
            method: "post",
            url: apiURL + "MasterData/GetWasteRequestList",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          this.isLoading = true;
          axios(config)
            .then((result) => {
			this.isLoading = false;
              if (result.data.status_code == 200) {
                var obj = result.data.response;
                var totrow = obj.length;
                var wasteData = [];
                for (var i = 0; i < totrow; i++) {
                  var wstatus = "";
                  if (obj[i].Request_Status == "01") {
                    var wstatus = "Pending";
                  } else if (obj[i].Request_Status == "02") {
                    var wstatus = "Postpone";
                  } else if (obj[i].Request_Status == "03") {
                    var wstatus = "Decline";
                  } else if (obj[i].Request_Status == "04") {
                    var wstatus = "Confirm";
                  }
                  var row = {
                    Request_ID: obj[i].Item_Id,
                    Date: obj[i].Request_Date,
                    Customer_Name: obj[i].Customer_Name,
                    Site_Name: obj[i].Site_Name,
                    Waste_Name: obj[i].Waste_Name,
                    Quantity: obj[i].Quantity,
                    Vehicle_Type: obj[i].Trucktype,
                    ManifestNo: obj[i].ManifestNo,
                    SAP_VehicleNo: obj[i].SAP_VehicleNo,
                    action: "Edit",
                  };
                  //Status:wstatus,ETA:obj[i].Request_Time,
                  wasteData.push(row);
                }
                this.items = wasteData;
              } else {
                /*self1.$swal.fire({
							  icon: 'error',
							  title: 'Oops...',
							  text: result.data.message		 
							})*/
                this.items = [];
              }
            })
            .catch((error) => {
			  this.isLoading = false;
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            });
        } else {
		  this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      })

      .catch((error) => {
		this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  },
  methods: {
    dateFilter_client() {
      console.log("date filter");
      this.getShuffledWasteDataFilter();
    },
    getShuffledWasteDataFilter() {
	  this.isLoading = true;
      //console.log('call');
      var value = $("#plantcodeOptions").val();
      var siteOptionsArr = this.siteArr;
      var self = this;
      var Plant_Code = "2302";
      var selArr = siteOptionsArr.find(function (jsonitem, i) {
        if (value == jsonitem.Plant_Name) {
          Plant_Code = jsonitem.Plant_Code;
          //console.log(Plant_Code);
        }
      });

      var firstdate = $("#clientvise_fromdate").val();
      var today = $("#clientvise_todate").val();
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var requestInfo = {
        Token: token,
        RequestFromDate: firstdate,
        RequestToDate: today,
        Session_User_Id: Session_User_Id,
        Plant_Code: Plant_Code,
      };
      var data = JSON.stringify(requestInfo);
      //console.log(data);
      var config = {
        method: "post",
        url: apiURL + "MasterData/GetWasteRequestList",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var self = this;
      axios(config)
        .then((result) => {
		  this.isLoading = false;
          if (result.data.status_code == 200) {
            var obj = result.data.response;
            var totrow = obj.length;
            var wasteData = [];
            for (var i = 0; i < totrow; i++) {
              var wstatus = "";
              if (obj[i].Request_Status == "01") {
                var wstatus = "Pending";
              } else if (obj[i].Request_Status == "02") {
                var wstatus = "Postpone";
              } else if (obj[i].Request_Status == "03") {
                var wstatus = "Decline";
              } else if (obj[i].Request_Status == "04") {
                var wstatus = "Confirm";
              }
              var row = {
                Request_ID: obj[i].Item_Id,
                Date: obj[i].Request_Date,
                Customer_Name: obj[i].Customer_Name,
                Site_Name: obj[i].Site_Name,
                Waste_Name: obj[i].Waste_Name,
                Quantity: obj[i].Quantity,
                Vehicle_Type: obj[i].Trucktype,
                ManifestNo: obj[i].ManifestNo,
                SAP_VehicleNo: obj[i].SAP_VehicleNo,
                action: "Edit",
              };
              //Status:wstatus,ETA:obj[i].Request_Time,
              wasteData.push(row);
            }
             this.items = wasteData;
          } else {
            /*self.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: result.data.message		 
            })*/
            this.items = [];
          }
        })
        .catch((error) => {
		  this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    add() {
      //console.log('add');
      this.$router.push({ path: "add_waste_lifting" });
    },
  },
};
</script>
